import {PhoneType} from '@yosmanyga/phone'

abstract class AuthenticationFrontendWithPhoneAbstractApi {
    abstract start: (
        phone: PhoneType
    ) => Promise<void>

    abstract complete: (
        phone: PhoneType,
        code: string
    ) => Promise<{
        token: string,
        user: string
    }>
}

export {
    AuthenticationFrontendWithPhoneAbstractApi
}
